import WalkInCustomerDetailsContainer from "./WalkInCustomerDetailsContainer";

export default WalkInCustomerDetailsContainer;
